/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Button, Table, Form, FormControl, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { serverUrl } from "../../../../serverUrl";
import { toast } from "react-toastify";
import BulkPaymentsApproval from "../payment_approvals/_bulkpayments";

export default function BulkPayments() {
    const { id } = useParams()
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(true);
    const [unpaidInvoice, setUnpaidInvoice] = useState([]);
    const [statusFilter, setStatusFilter] = useState("all");
    const [apartmentFilter, setApartmentFilter] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [sortType, setSortType] = useState("invoice");
    const [loggedInUser, setLoggedInUser] = useState(null)
    const [sortOrder, setSortOrder] = useState("asc");
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [activeTab, setActiveTab] = useState("unpaid");

    const [paymentData, setPaymentData] = useState({
        date_paid: "",
        amount_paid: "",
        payment_method: "",
        transaction_number: "",
        transaction_date: ""
    });

    const itemsPerPage = 10;

    // Get access token
    const accessToken = localStorage.getItem("authTokens");
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const config = { headers: { Authorization: `Bearer ${access}` } };

    useEffect(() => {
        const token = localStorage.getItem("authTokens");
        if (!token) {
            navigate("/login");
            return;
        }

        const parsedTokens = JSON.parse(token);
        const decodedToken = jwt_decode(token);
        const userId = decodedToken.user_id;
        setLoggedInUser(userId)

        serverUrl
            .get(`/landlord/landlord/?user_id=${userId}`, config)
            .then((res) => {
                const landlordId = res.data.results[0].id;
                serverUrl
                    .get(`/landlord/${landlordId}/upload_payments_invoices`, config)
                    .then((res) => {
                        setUnpaidInvoice(res.data);
                        console.log(res.data)
                    })
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, [navigate]);

    const handleSearch = (event) => setSearchQuery(event.target.value);
    const handleSort = (sortField) => {
        setSortType(sortField);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };
    const handleStatusFilterChange = (event) => setStatusFilter(event.target.value);
    const handleApartmentFilterChange = (event) => setApartmentFilter(event.target.value);

    const sortedData = unpaidInvoice.sort((a, b) => {
        const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
        const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];
        return sortOrder === "asc" ? (sortValueA > sortValueB ? 1 : -1) : (sortValueA < sortValueB ? 1 : -1);
    });

    const filteredData = unpaidInvoice.filter((item) => {
        const searchableFields = Object.values(item).join(" ").toLowerCase();
        const matchesSearch = searchableFields.includes(searchQuery.toLowerCase());

        const matchesStatus = statusFilter === "all" || item.unit_status === statusFilter;
        const matchesApartment = apartmentFilter === "all" || item.apartment === apartmentFilter;

        return matchesSearch && matchesStatus && matchesApartment;
    });

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const displayedItems = filteredData.slice(startIndex, endIndex);

    const handlePrevPage = () => setCurrentPage((prev) => prev - 1);
    const handleNextPage = () => setCurrentPage((prev) => prev + 1);

    const handleDownloadCSV = () => {
        const headers = [
            "Invoice ID",
            "Unit Number",
            "Apartment",
            "Amount",
            "Balance",
            "Status",
            "Reference",
            "Utility",
            "Tenant",
            "Tenant Phone",
            "Month",
            "Year"
        ];
        const rows = filteredData.map(invoice => [
            `INV${invoice.invoice_id}`,
            invoice.house_name,
            invoice.apartment,
            `KSH. ${parseInt(invoice.amount)?.toLocaleString('en-us')}`,
            `KSH. ${parseInt(invoice.balance_amount)?.toLocaleString('en-us')}`,
            invoice.status,
            invoice.reference === "expense" ? "Utility" : invoice.reference,
            invoice.utility,
            invoice.tenant_name,
            invoice.tenant_phone,
            invoice.month,
            invoice.year
        ]);
        const csvContent = [
            headers.join(","),
            ...rows.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
        ].join("\r\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "unpaid_invoices.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const uniqueApartments = [...new Set(unpaidInvoice.map((item) => item.apartment))];

    const getSortIcon = (field) => {
        if (sortType === field) {
            return sortOrder === "asc" ? (
                <i className="bi bi-chevron-up"></i>
            ) : (
                <i className="bi bi-chevron-down"></i>
            );
        }
        return <i className="bi bi-arrow-down-up"></i>;
    };

    const handleOpenPaymentModal = (invoice) => {
        setSelectedInvoice(invoice);
        setPaymentData({
            date_paid: new Date().toISOString().split('T')[0],
            amount_paid: invoice.balance < 0 ? 0 : invoice.balance,

            payment_method: "",
            transaction_number: "",
            transaction_date: new Date().toISOString().split('T')[0]
        });
        setShowPaymentModal(true);
    };

    const handleClosePaymentModal = () => {
        setShowPaymentModal(false);
        setSelectedInvoice(null);
        setPaymentData({
            date_paid: "",
            amount_paid: "",
            payment_method: "",
            transaction_number: "",
            transaction_date: ""
        });
    };

    const handlePaymentInputChange = (e) => {
        const { name, value } = e.target;
        setPaymentData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePaymentSubmit = (e) => {
        e.preventDefault();
        setIsProcessingPayment(true);

        // Generate a cash invoice number if payment method is cash
        const transactionId = paymentData.payment_method === "cash"
            ? `CASH-${Date.now()}`
            : paymentData.transaction_number;

        const data = {
            apartment: selectedInvoice.apartment_id,
            house: selectedInvoice.house_id,
            payment_amount: paymentData.amount_paid,
            payment_date: paymentData.date_paid,
            payment_method: paymentData.payment_method,
            added_by: loggedInUser,
            tenant: selectedInvoice.tenant_id,
            transaction_id: transactionId,
            transaction_date: paymentData.transaction_date,
        }

        serverUrl.post('/landlord/payment-approvals/', data, config)
            .then(response => {
                toast.success("Payment recorded successfully");
                serverUrl
                    .get(`/landlord/landlord/?user_id=${loggedInUser}`, config)
                    .then((res) => {
                        const landlordId = res.data.results[0].id;
                        serverUrl
                            .get(`/landlord/${landlordId}/upload_payments_invoices`, config)
                            .then((res) => {
                                setUnpaidInvoice(res.data);
                                setIsProcessingPayment(false);
                                handleClosePaymentModal();
                            })
                            .catch((error) => {
                                console.log(error);
                                setIsProcessingPayment(false);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsProcessingPayment(false);
                    });
            })
            .catch(error => {
                toast.error("Error recording payment");
                setIsProcessingPayment(false);
                console.error(error);
            });
    };

    return (
        <div className="bg-white shadow-md mt-2 px-2 rounded-lg">
            <div className="p-4">

                <h5 className="mb-2 font-semibold text-lg">Bulk Payments</h5>

                {/* Tabs */}
                <div className="mb-2 border-gray-200 border-b">
                    <nav className="flex space-x-8 -mb-px">
                        <button
                            onClick={() => setActiveTab("unpaid")}
                            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "unpaid"
                                ? "border-blue-500 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
                        >
                            Unpaid Invoices
                        </button>
                        <button
                            onClick={() => setActiveTab("approved")}
                            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "approved"
                                ? "border-blue-500 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
                        >
                            Recorded Payments
                        </button>
                    </nav>
                </div>

            </div>


            {activeTab === 'unpaid' ?
                <>
                    <div className="p-2" >
                        {/* <h5>List of Unpaid Invoices</h5> */}
                        <div className="d-flex justify-content-between mb-3 filters">
                            <Form className="searchBar">
                                <FormControl
                                    type="text"
                                    placeholder="Search"
                                    className='bg-white border border-secondary'
                                    value={searchQuery}
                                    onChange={handleSearch}
                                />
                            </Form>
                            <div className="d-flex">
                                <Form.Select value={statusFilter} onChange={handleStatusFilterChange} className="w-auto">
                                    <option value="all">All Payments</option>
                                    <option value="unpaid">Unpaid</option>
                                    <option value="partial">Partially Paid</option>
                                    <option value="overpaid">Overpaid Paid</option>
                                    <option value="paid">Fully Paid</option>
                                </Form.Select>
                                <Form.Select value={apartmentFilter} onChange={handleApartmentFilterChange} className="ms-3 w-auto">
                                    <option value="all">All Properties</option>
                                    {uniqueApartments.map((apartment, index) => (
                                        <option key={index} value={apartment}>{apartment}</option>
                                    ))}
                                </Form.Select>
                                <Button variant="success" className="ms-3" onClick={handleDownloadCSV}>
                                    Download CSV
                                </Button>
                            </div>
                        </div>
                        <Table>
                            <thead className="mt-2">
                                <tr style={{ textAlign: "left" }}>
                                    <th onClick={() => handleSort("house_name")}> Unit Number {getSortIcon("house_name")}</th>
                                    <th onClick={() => handleSort("apartment_name")}> Apartment {getSortIcon("apartment_name")}</th>
                                    <th onClick={() => handleSort("total_due")}>Total Amount {getSortIcon("total_due")}</th>
                                    <th onClick={() => handleSort("balance")}>Balance {getSortIcon("balance")}</th>
                                    <th onClick={() => handleSort("unit_status")}>Status {getSortIcon("unit_status")}</th>
                                    <th onClick={() => handleSort("tenant_name")}>Tenant {getSortIcon("tenant_name")}</th>
                                    <th onClick={() => handleSort("tenant_phone")}>Tenant Phone {getSortIcon("tenant_phone")}</th>
                                    <th >Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedItems.map((invoice) => (
                                    <tr key={invoice.id} className="" style={{ textAlign: "left" }}>
                                        <td>
                                            <Link to={`/selected-house/${invoice.house_id}`}>
                                                {invoice.house_name}
                                            </Link>
                                        </td>
                                        <td>{invoice.apartment_name}</td>
                                        <td>KSH. {parseInt(invoice.total_due)?.toLocaleString('en-us')}</td>
                                        <td>KSH. {parseInt(invoice.balance)?.toLocaleString('en-us')}</td>
                                        <td>
                                            <Button
                                                className={
                                                    invoice.unit_status === "partial"
                                                        ? "btn btn-sm btn-secondary text-white"
                                                        : invoice.unit_status === "paid" ? "btn btn-sm btn-success"
                                                            : invoice.unit_status === "unpaid" ? "btn btn-sm btn-danger"
                                                                : "btn btn-sm btn-warning text-white"
                                                }
                                            >
                                                {invoice.unit_status}
                                            </Button>
                                        </td>
                                        <td className='text-capitalize'>{invoice.tenant_name}</td>
                                        <td className='text-capitalize'>{invoice.tenant_phone}</td>
                                        <td>
                                            <Button onClick={() => handleOpenPaymentModal(invoice)}
                                                className='text-white btn btn-sm btn-info'>Add Payment</Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="pagination">
                            <Button onClick={handlePrevPage} disabled={currentPage === 0}>
                                &lt;
                            </Button>
                            <span>
                                {startIndex + 1}-{Math.min(endIndex, filteredData.length)} of {filteredData.length}
                            </span>
                            <Button onClick={handleNextPage} disabled={currentPage === totalPages - 1}>
                                &gt;
                            </Button>
                        </div>

                        {/* Payment Modal */}
                        <Modal show={showPaymentModal} onHide={handleClosePaymentModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Record Payment</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {selectedInvoice && (
                                    <Form onSubmit={handlePaymentSubmit}>
                                        <Form.Group className="mb-3">
                                            <p>Date Receipt</p>
                                            <Form.Control
                                                type="date"
                                                name="date_paid"
                                                value={paymentData.date_paid}
                                                onChange={handlePaymentInputChange}
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <p>Amount Paid</p>
                                            <Form.Control
                                                type="number"
                                                name="amount_paid"
                                                value={paymentData.amount_paid}
                                                onChange={handlePaymentInputChange}

                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <p>Payment Method</p>
                                            <Form.Select
                                                name="payment_method"
                                                value={paymentData.payment_method}
                                                onChange={handlePaymentInputChange}
                                                required
                                            >
                                                <option value="">-- Select Method --</option>
                                                <option value="mpesa">Mpesa</option>
                                                <option value="bank_deposit">Bank Deposit</option>
                                                <option value="cheque">Cheque</option>
                                                <option value="cash">Cash</option>
                                            </Form.Select>
                                        </Form.Group>

                                        {(paymentData.payment_method === "mpesa" || paymentData.payment_method === "bank_deposit") && (
                                            <>
                                                <Form.Group className="mb-3">
                                                    <p>Transaction Number</p>
                                                    <Form.Control
                                                        type="text"
                                                        name="transaction_number"
                                                        value={paymentData.transaction_number}
                                                        onChange={handlePaymentInputChange}
                                                        required
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <p>Date of Transaction</p>
                                                    <Form.Control
                                                        type="date"
                                                        name="transaction_date"
                                                        value={paymentData.transaction_date}
                                                        onChange={handlePaymentInputChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </>
                                        )}

                                        {paymentData.payment_method === "cheque" && (
                                            <>
                                                <Form.Group className="mb-3">
                                                    <p>Cheque Number</p>
                                                    <Form.Control
                                                        type="text"
                                                        name="transaction_number"
                                                        value={paymentData.transaction_number}
                                                        onChange={handlePaymentInputChange}
                                                        required
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <p>Date of Cheque</p>
                                                    <Form.Control
                                                        type="date"
                                                        name="transaction_date"
                                                        value={paymentData.transaction_date}
                                                        onChange={handlePaymentInputChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </>
                                        )}
                                        <div className="d-flex justify-content-end">
                                            <Button variant="secondary" onClick={handleClosePaymentModal} className="me-2">
                                                Cancel
                                            </Button>
                                            <Button variant="primary" type="submit" disabled={isProcessingPayment}>
                                                {isProcessingPayment ? (
                                                    <div className="flex justify-center items-center">
                                                        <div className="mr-2 border-white border-b-2 rounded-full w-4 h-4 animate-spin"></div>
                                                        Processing...
                                                    </div>
                                                ) : "Record Payment"}
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Modal.Body>
                        </Modal>
                    </div>
                </>
                :
                <>
                    <BulkPaymentsApproval />
                </>

            }
        </div>
    );
}